import { render, staticRenderFns } from "./MembersHeader.vue?vue&type=template&id=20a529e5&scoped=true&"
import script from "./MembersHeader.vue?vue&type=script&lang=js&"
export * from "./MembersHeader.vue?vue&type=script&lang=js&"
import style0 from "./MembersHeader.vue?vue&type=style&index=0&id=20a529e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a529e5",
  null
  
)

export default component.exports